import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteModel } from 'src/app/models/quote.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.scss'],
})
export class PremiumComponent implements OnInit {

  @Input() quote: QuoteModel;
  @Input() mode: 'lta' | 'dta';
  @Input() helpKey: string;

  @Output() continue = new EventEmitter<QuoteModel>();

  devMode = !environment.production;

  constructor(
  ) { }

  ngOnInit() {
  }
}
